import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="mx-auto max-w-[1000px] border-t border-border/60 px-4 py-6 text-center text-[13px] text-muted-foreground"
    >
      Made by:{" "}
      <a
        href="https://x.com/adityabhandari1"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-author-link"
        className="font-medium text-foreground transition-colors hover:text-brand"
      >
        Aditya Bhandari
      </a>
    </footer>
  );
}
